export const toggleConfig = {
  assignVenueSectionsToRunner: true,
};
